import { useAppStateStore } from '@/js/core/stores/app-state-store';
import { useCurrentPageStore } from '@/js/core/stores/current-page-store';
import { useTrayViewStore } from '@/js/core/stores/tray-view-store';
import { useUserStore } from '@/js/core/stores/user-store';

const hydratedStoreLoaders = {
  appConfiguration: useAppStateStore,
  currentPage: useCurrentPageStore,
  userData: useUserStore,
};

/**
 * Hydrates Pinia stores from the server-provided app payload.
 */
export function useAppHydration(props) {
  const trayViewStore = useTrayViewStore();

  const hydrateAppStores = () => {
    Object.keys(props).forEach(propKey => {
      const storeLoader = hydratedStoreLoaders[propKey];

      if (!storeLoader) {
        warnInDev(`[Hydration] No store found for prop '${propKey}'.`);
        return;
      }

      const store = storeLoader();
      const dataFromWindow = window.gsdNowAppData[propKey];

      if (dataFromWindow) {
        hydrateStore(store, dataFromWindow);
      } else {
        warnInDev(`[Hydration] window.${propKey} is missing; using default prop.`);
      }
    });

    const appData = window.gsdNowAppData || {};
    if (appData.trayView) {
      trayViewStore.setFromHydration(appData.trayView);
    }
  };

  return {
    hydrateAppStores,
  };
}

function hydrateStore(store, dataFromWindow) {
  for (const fieldName in dataFromWindow) {
    if (fieldName in store) {
      store[fieldName] = dataFromWindow[fieldName];
    } else {
      warnInDev(`[Hydration] Store has no property '${fieldName}'.`);
    }
  }
}

function warnInDev(message) {
  if (import.meta.env.DEV) {
    console.warn(message);
  }
}
